// import { Link } from 'found'
import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro';

import LinkResolver from '../../link-resolver'

import arrowIcon from '../../images/ARROW-FW.svg'
import linkedInIcon from '../../images/email/linkedin.png'
import instagramIcon from '../../images/instagram.svg'
import twitterIcon from '../../images/icon-share-twitter.svg'
import youtubeIcon from '../../images/youtube.svg'
import facebookIcon from '../../images/icon-share-facebook.svg'

class Footer extends Component {

    render() {
        const { facebookLink, twitterLink, instagramLink, linkedinLink, youtubeLink } = this.props.footer
        const { leftColumn, rightColumn } = this.props.footer

        return (
            <div className="footer">
                <div className="footerrow">
                    <div className="row-21 w-row">
                        <div className="column-9 w-col w-col-4 w-col-medium-4 w-col-small-small-stack w-col-tiny-tiny-stack">
                            {leftColumn.map((item, key) =>
                                <a
                                    key={key}
                                    target={item.link.target || ''}
                                    href={item.link.url || LinkResolver(item.link)}
                                    className="footer-li"
                                >
                                    {item.title}
                                </a>
                            )}
                        </div>
                        <div className="column-56 w-col w-col-4 w-col-medium-4 w-col-small-small-stack w-col-tiny-tiny-stack">
                            {rightColumn.map((item, key) =>
                                <a
                                    key={key}
                                    target={item.link.target || ''}
                                    href={item.link.url || LinkResolver(item.link)}
                                    className="footer-li"
                                >
                                    {item.title}
                                </a>
                            )}
                            <div className="social-iconsm">
                                {facebookLink &&
                                    <a target="_blank" href={facebookLink}>
                                        <img alt="" src={facebookIcon} width={24} height={24} className="social-icon white" />
                                    </a>
                                }
                                {twitterLink &&
                                    <a target="_blank" href={twitterLink}>
                                        <img alt="" src={twitterIcon} width={24} height={24} className="social-icon" />
                                    </a>
                                }
                                {instagramLink &&
                                    <a target="_blank" href={instagramLink}>
                                        <img alt="" src={instagramIcon} width={24} height={24} className="social-icon" />
                                    </a>
                                }
                                {linkedinLink &&
                                    <a target="_blank" href={linkedinLink}>
                                        <img alt="" src={linkedInIcon} width={24} className="social-icon" />
                                    </a>
                                }
                                {youtubeLink &&
                                    <a target="_blank" href={youtubeLink}>
                                        <img alt="" src={youtubeIcon} width={24} />
                                    </a>
                                }
                            </div>
                        </div>
                        <div className="column-57 w-col w-col-4 w-col-medium-4 w-col-small-small-stack w-col-tiny-tiny-stack">
                            <h1><strong className="footer-header">Subscribe to our newsletter to receive news, alerts and&nbsp;updates</strong></h1>
                            <div className="form-block">
                                <form id="email-form" name="email-form"  method="get" target="_blank" noValidate data-name="Email Form" className="form" action="https://startupguide.eo.page/g4t6f">
                                    <div className="div-block-9"><input type="email" className="text-field w-input" maxLength={256} name="EmailAddress" data-name="Email 2" placeholder="Your email *" id="email-2" required />
                                        <div className="div-block-10 w-clearfix"><input type="submit" defaultValue="Sign me up" data-wait="Please wait..." className="button small secondary white w-button" /><img alt="" src={arrowIcon} width={10} className="image-37" /></div>
                                    </div>
                                </form>
                                <div className="w-form-done">
                                    <div>Thank you! Your submission has been received!</div>
                                </div>
                                <div className="w-form-fail">
                                    <div>Oops! Something went wrong while submitting the form.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default createFragmentContainer(
    Footer,
    graphql`
        fragment footer_footer on Footer {
            facebookLink
            twitterLink
            instagramLink
            linkedinLink
            youtubeLink
            leftColumn {
                title
                link {
                    id
                    uid
                    type
                    slug
                    link_type
                    url
                    target
                }
            }
            rightColumn {
                title
                link {
                    id
                    uid
                    type
                    slug
                    link_type
                    url
                    target
                }
            }
        }
    `
)
